export default __webpack_public_path__ + "static/media/IResponsiveTOIFullSize.d0dffe6c.png";